import {
  mapDashboardSummaryDto,
  type DashboardSummary,
  type DashboardSummaryDto,
} from '@/types';

import type { DashboardService } from '../dashboardService';
import { httpRequestWithRefresh, type HttpClientConfig } from './httpApiClient';
import { unwrapResult } from './httpEnvelope';

/**
 * HTTP impl of :type:`DashboardService`(T1 / docs/49 §8)。
 * `GET /api/dashboard`;非 exempt → `httpRequestWithRefresh` 自動帶 `X-Current-Group`。
 */

const PATH = '/api/dashboard';

export function createHttpDashboardService(config: HttpClientConfig): DashboardService {
  return {
    async getDashboard(): Promise<DashboardSummary> {
      const env = await httpRequestWithRefresh<DashboardSummaryDto>(config, 'GET', PATH);
      return mapDashboardSummaryDto(unwrapResult(env, 'dashboard.getDashboard'));
    },
  };
}
